'use strict';

var AbstractTableRowView = require('components/common/views/abstract_table_row_view');
var App = require('app');
var AppState = require('app_state');
var i18n = require('utils/i18n');
var Misc = require('utils/misc');
var Notification = require('utils/notification');
var Utils = require('components/common/utils');

var AbstractTableView = Marionette.CompositeView.extend({
    template: require('components/common/templates/abstract_table'),

    childView: AbstractTableRowView,
    childViewContainer: 'tbody',

    itemsPerPage: 20,
    minItemsPerPage: 10,
    currentPage: 1,
    pageButtonCount: 9,
    pageButtonCountLg: 20,
    enableURLHistory: false,

    enableCompactMode: false,
    isCompactMode: false,

    sortCols: [],

    ui: function () {
        return {
            btnCSVdownload: 'a.js-csv-download',
            btnsSelection: '.js-selection-buttons div, #js-selection-action-menu, .js-action',
            cbSelectAll: '.js-select-all',
        };
    },

    events: {
        'click input.js-table-row-select': 'rowSelected',
        'click #js-delete': 'deleteSelectedRows',
        'click div.js-tab-btn-refresh': 'refreshTable',
        'click .pagination li a': 'selectPageClick',
        'click .js-model-action': 'triggerModelAction',
        'change .pagination li a select': 'selectPageSelect',
        'change .tab-pagination select': 'setItemsPerPage',
        'click #table-mode-btn': 'switchMode',
    },

    setItemsPerPage: function (value) {
        if (this.controller && this.controller.setItemsPerPage) {
            this.controller.setItemsPerPage(value);
        } else {
            AppState.saveItemsPerPage(value);
        }
        this.itemsPerPage = value;
        this.initPagination();
        this.gotoPage();
    },

    columnClicked: function (e) {
        this.attachSortColumns();

        var th = $(e.currentTarget).closest('th');
        var sortIdx = $(th).attr('data-sort-idx');
        var sortCol = this.sortCols[sortIdx];
        var sortDesc = sortCol === this.currentSortCol ? !this.currentSortDesc : true;

        this.gotoPage(1, sortCol, sortDesc);
        e.stopPropagation();
    },

    initPagination: function () {
        if (this.itemsPerPage < 10 || this.itemsPerPage > 100) {
            // do not allow showing 'all' items anymore
            // -> use default for invalid values
            this.itemsPerPage = 20;
        }
        this.pageCount = Math.ceil(this.itemCount / this.itemsPerPage);
        this.currentPage = Math.min(this.currentPage, this.pageCount);
    },

    getCurrentTargetID: function (e) {
        return $(e.currentTarget).parents('tr').attr('data-row-id');
    },

    initialize: function (options) {
        this.options = options;

        this.itemsPerPage = options.itemsPerPage || this.itemsPerPage;
        this.itemCount = options.itemCount;
        this.listResult = options.listResult;

        var params = AppState.getURLParameter(['sortCol', 'sortDesc', 'page']);
        if (params.sortDesc && typeof params.sortDesc === 'string') {
            params.sortDesc = params.sortDesc === 'true';
        }
        this.currentSortCol = options.sortCol || params.sortCol || 'name';
        this.currentSortDesc = options.sortDesc || params.sortDesc || false;
        this.currentPage = options.currentPage || params.page || 1;
        this.itemCount = this.itemCount || params.itemCount;

        this.initPagination();
    },

    updateURL: function () {
        if (!this.enableURLHistory) {
            return;
        }
        AppState.setURLParameter(
            {
                sortCol: this.currentSortCol,
                sortDesc: this.currentSortDesc,
                page: this.currentPage,
                itemCount: this.itemCount,
            },
            'update'
        );
    },

    attachSortColumns: function (e) {
        var self = this;
        if (this.options.getSortColumn) {
            var idx = 1;
            _.each(this.options.columns, function (c) {
                var col = self.options.getSortColumn(c);
                if (col) {
                    self.sortCols[idx] = col;
                    c.sortIdx = idx;
                    c.isSortDescending = col == self.currentSortCol && self.currentSortDesc;
                    c.isSortDefault = col == self.currentSortCol;
                    idx++;
                } else {
                    c.notSortable = true;
                }
            });
        }
    },

    selectPageSelect: function (e) {
        var page = parseInt($(e.currentTarget).val());
        this.gotoPage(page);
        this.updateURL();
        e.stopPropagation();
    },

    gotoPage: function (page, sortCol, sortDesc) {
        var self = this;
        if (this.listResult.setPage && this.isInitialized) {
            page = page || this.currentPage;
            sortCol = sortCol || this.currentSortCol;
            sortDesc = sortDesc !== undefined ? sortDesc : this.currentSortDesc;
            if (this.itemsPerPage == -1) page = 1;

            var setPageComplete = function (page, sortCol, sortDesc, items, count) {
                self.collection = items;
                self.itemCount = count;
                self.currentPage = page;
                self.currentSortCol = sortCol;
                self.currentSortDesc = sortDesc;
                self.initPagination();
                self.render();
                self.updateURL();
            };

            this.listResult.setPage(page, this.itemsPerPage, sortCol, sortDesc, function (items, count) {
                if (items.promise && items.done) {
                    var promise = items;
                    $.when(promise).done(function (result) {
                        var hasGet = result.get !== undefined;
                        var collection = (hasGet ? result.get('collection') : undefined) || result.collection;
                        var resultCount = (hasGet ? result.get('count') : undefined) || result.count;
                        setPageComplete(page, sortCol, sortDesc, collection, resultCount);
                        return;
                    });
                    return;
                }
                setPageComplete(page, sortCol, sortDesc, items, count);
            });
        }
        this.isInitialized = true;
    },

    selectPageClick: function (e) {
        var page = parseInt($(e.currentTarget).text());
        e.preventDefault();
        var isPageNrVisible = $(e.currentTarget).find('.js-tab-pagination-page-nr').is(':visible');
        if (page > 0 && isPageNrVisible) {
            if ($(e.target).closest('.pagination-form').length == 0) {
                e.stopPropagation();
                this.gotoPage(page);
                this.updateURL();
            }
        } else {
            // toggle the visibilty of ... and form
            var isDropDownVisible = $(e.currentTarget).find('.pagination-form').is(':visible');
            $(e.currentTarget).find('.pagination-dots').hide();
            $(e.currentTarget).find('.pagination-form').show();
            Misc.initSelectPicker();

            var sel = $(e.currentTarget).find('select');

            if (!isDropDownVisible) {
                setTimeout(function () {
                    sel.selectpicker('toggle');
                }, 100);
            }
        }
    },

    initializeReadOnly: function (options) {
        // override current configuration options -> set to read-only mode
        this.options.hasSelectionButtons = false;
        this.options.selectionButtons = [];
        this.options.customButtons = [];
    },

    childViewOptions: function () {
        return {
            columns: this.options.columns,
            hasSelectionButtons: this.options.hasSelectionButtons,
            context: this.options.context,
        };
    },

    serializeData: function () {
        var data = Marionette.CompositeView.prototype.serializeData.apply(this, arguments);
        data.options = this.options;
        data.options.title = data.options.title
            ? data.options.title.replace('{{itemCount}}', this.itemCount)
            : undefined;

        data.columns = _.clone(this.options.columns);
        data.context = this.options.context;
        data.nrModels = this.collection.length;
        data.nrSelected = this.collection.selectedLength;
        data.itemsPerPage = this.itemsPerPage;
        data.showPagination = this.pageCount > 1;
        data.showPageCountSelect = this.itemsCount <= this.minItemsPerPage;
        data.isCompactMode = this.isCompactMode;

        this.attachColumnDisplayMethods(data.columns);
        this.attachSortColumns();

        return data;
    },

    attachColumnDisplayMethods: function (columns) {
        var self = this;
        _.each(columns, function (col) {
            if (col.displayMethod) {
                var fct = self.options.displayMethods[col.displayMethod];
                if (fct) {
                    col.displayMethod = function (value, model, col) {
                        return fct.apply(self, [value, model, col]);
                    };
                }
            }
        });
    },

    deleteSelectedRows: function (e) {
        var self = this;

        e.preventDefault();
        Utils.deleteModels({
            models: this.collection.selected,
            success: function () {
                if (self.options.isRedirectToHomeIfEmpty === true && self.collection.length == 0) {
                    App.trigger('home:show');
                    return;
                }
                Notification.show('success', i18n.TR('Erfolg'), i18n.TR('Die Einträge wurden gelöscht.'));
                self.afterDeleteSelectedRows();
            },
            deleteFct: this.doDeleteSelectedRows,
        });
    },

    afterDeleteSelectedRows: function () {
        this.render();
    },

    rowSelected: function (e) {
        var $target = $(e.currentTarget);
        var id = $target.attr('data-row-id');
        if (id === 'select-all') {
            // table header selection -> select or deselect all
            this.collection.toggleAllSelectable();
        } else {
            // table row selection -> toggle row
            var rowModel = this.collection.get(id);
            rowModel.toggleSelected();
        }

        this.updateSelectionRows();
        this.updateSelectionButtons();
    },

    updateSelectionRows: function () {
        var self = this;
        var $el = $(self.el);
        _.each(this.collection.models, function (rowModel) {
            if (rowModel.selectable === false) {
                // skip models that can not be selected
                return;
            }

            var $tableRow = $el.find('tr[data-row-id="' + rowModel.id + '"]');
            if (rowModel.selected) {
                $tableRow.addClass('selected');
            } else {
                $tableRow.removeClass('selected');
            }

            var $rowCheckBox = $tableRow.find('.js-table-row-select');
            $rowCheckBox.prop('checked', rowModel.selected);
        });

        this.ui.cbSelectAll.prop('checked', this.collection.selectedLength === this.collection.selectableLength());
    },

    updateSelectionButtons: function () {
        // no selection buttons? -> do nothing
        if (!this.options.hasSelectionButtons) {
            return;
        }

        if (this.collection.selectedLength == 0) {
            this.ui.btnsSelection.addClass('disabled');
        } else {
            this.ui.btnsSelection.removeClass('disabled');
        }

        this.updateCSVlink();
    },

    refreshTable: function (e) {
        // reload current route
        Backbone.history.loadUrl(Backbone.history.fragment);
    },

    attachPagination: function () {
        var p = Misc.generatePagination({
            currentPage: this.currentPage,
            pageCount: this.pageCount,
            totalCount: this.itemCount,
            itemsPerPage: this.itemsPerPage,
            context: this,
            onGotoPage: this.gotoPage,
            onSetItemsPerPage: this.setItemsPerPage,
        });

        this.$el.find('.tablesaw-bar').append(p.html);
        p.initEvents();
    },

    attachCompactModeButton: function () {
        if (!this.options.enableCompactMode) {
            return;
        }

        // check whether at least on column has short name
        var disableCompactModeButton =
            _.reduce(
                this.options.columns,
                function (memo, e) {
                    return memo + (e.abbreviation !== undefined ? 1 : 0);
                },
                0
            ) == 0;

        this.$el
            .find('.tablesaw-advance')
            .append(
                '<a id="table-mode-btn" class="tablesaw-nav-btn btn btn-micro table-mode' +
                    (disabeCompactModeButton ? ' disabled" disabled="disabled' : '') +
                    '" title="' +
                    (this.isCompactMode ? i18n.TR('Normal') : i18n.TR('Kompakt')) +
                    '"><i id="mode-icon" class="fa fa-' +
                    (this.isCompactMode ? 'expand' : 'compress') +
                    '"></i></a>'
            );
    },

    switchMode: function (e) {
        var $icon = $('#mode-icon');

        this.isCompactMode = !this.isCompactMode;
        $icon.removeClass('fa-' + (this.isCompactMode ? 'compress' : 'expand'));
        $icon.addClass('fa-' + (this.isCompactMode ? 'expand' : 'compress'));

        this.render();
    },

    onShow: function () {
        if (this.listResult) {
            this.gotoPage(this.currentPage, this.currentSortCol, this.currentSortDesc);
        }
    },

    onAttach: function () {
        $(document).trigger('enhance.tablesaw');
        this.attachTableColEvents();
        this.attachPagination();
        this.attachCompactModeButton();
        this.initializeCustomSorting();
        Misc.initSelectPicker();
    },

    onRender: function () {
        $(document).trigger('enhance.tablesaw');
        this.updateSelectionRows();
        this.updateSelectionButtons();
        this.attachTableColEvents();
        this.attachPagination();
        this.attachCompactModeButton();
        this.initializeCustomSorting();
        Misc.initSelectPicker();
    },

    attachTableColEvents: function () {
        var self = this;
        if (this.listResult && this.listResult.setPage) {
            var sortButtons = $(this.el).find('button.tablesaw-sortable-btn');
            sortButtons.unbind('click');
            sortButtons.on('click', function (e) {
                self.columnClicked(e);
                e.stopPropagation();
                e.preventDefault();
            });
        }
    },

    updateCSVlink: function () {
        var idFilter = '';
        if (this.collection.selectedLength != 0) {
            _.each(this.collection.selected, function (model) {
                if (idFilter == '') {
                    idFilter = '&id=' + model.id;
                } else {
                    idFilter += '%2C' + model.id;
                }
            });
        }
        var sorting = '&sort_col=' + Misc.correctSortCol(this.currentSortCol) + '&sort_desc=' + this.currentSortDesc;
        this.ui.btnCSVdownload.attr('href', this.options.CSVLink + idFilter + sorting);
    },

    modelAction: function () {},

    triggerModelAction: function (e) {
        e.preventDefault();
        var modelID = this.getCurrentTargetID(e);
        this.modelAction(e, modelID);
    },

    initializeCustomSorting: function () {},
});

module.exports = AbstractTableView;
